import React from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';


// const useStyles = makeStyles(theme => ({
//     root: {
//         width: '100%',
//         maxWidth: 360,
//         backgroundColor: theme.palette.background.paper,
//     },
//     // nested: {
//     //     paddingLeft: theme.spacing(4),
//     // },
// }));

export default function NestedList(props) {
    //const classes = useStyles();
    const [open, setOpen] = React.useState(props.name === 'Layers');

    function handleClick() {
        setOpen(!open);
    }

    let items = props.items ? props.items.map((item, index) =>
        <ListItem key={index} style={{ marginLeft: '10px'}}>
            <ListItemText primary={item.title} />
            <Checkbox
                style={{ marginLeft: '10px', marginRight: '20px', position: 'absolute', right: 0 }}
                checked={item.value}
                title={item.title}
                name={item.title}
                onChange={() => props.toogleStateAction(item.name)}
                color='primary'
                key={item.name}
            />
        </ListItem>) : null;

    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
        >
            <ListItem button onClick={handleClick}>
                <ListItemIcon>
                    <img src={props.icon} alt={props.name} height="30" width="30" title='OHL search' />
                </ListItemIcon>
                <ListItemText primary={props.name} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {items}
            </Collapse>
        </List>
    );
}
